import { enableProdMode, isDevMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { browserTracingIntegration, graphqlClientIntegration, httpClientIntegration, init, replayIntegration } from '@sentry/angular';
import { AppModule } from './app/app.module';

if (!isDevMode()) {
  enableProdMode();

  init({
    sendDefaultPii: true,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    dsn: 'https://6b692b40521396a9f9fc12ed4331bab8@o4509292325044224.ingest.us.sentry.io/4509292327272448',
    integrations: [
      httpClientIntegration(),
      browserTracingIntegration(),
      graphqlClientIntegration({
        endpoints: [/.*/],
      }),
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
  });
}

platformBrowserDynamic().bootstrapModule(AppModule);
